module.exports = __webpack_public_path__ + "static/img/bg71.fdbcabda.png";